import AdvertisingMediaImportPage from './AdvertisingMediaImportPage';

export default AdvertisingMediaImportPage;
